export default {
    login: '/autentimine/aup',
    logOut: '/autentimine/logout',
    kontrolliAuth: '/autentimine/onAuth',
    backToVatek: '/autentimine/tagasi-vatek',
    logoutVatek: '/autentimine/logout-vatek'
}